import Router from 'next/router';
import { useEffect } from 'react';
import { loadAdobeAnalytics } from '../../tracking/adobe';
import TrackingService from '../../tracking/TrackingService';
import { ABTest } from '../../utils/ABTesting';

const useGlobalInit = () => {
  useEffect(() => {
    const initializeGlobal = async () => {
      try {
        const { loadTrackingScripts, setupTracking, trackPage } = TrackingService();

        ABTest.initScenarios();
        setupTracking();

        await loadAdobeAnalytics();
        await loadTrackingScripts();

        // By doing the trackPage here, the app rendering/hydration isn't blocked by our tracker usage
        // Potential downside: If the users navigate to another page within the app,
        // this new page visit might not be tracked if the click happened before the trackers were
        // initialized. The alternative would be to block the rendering/hydration until tracker inits are done.
        trackPage();

        if (Router.router) {
          Router.router.events.on('routeChangeComplete', trackPage);
        }
      } catch (err) {
        console.error('client side global js init failed', err);
      }
    };

    initializeGlobal();
  }, []);
};

export default useGlobalInit;
